import styled from "styled-components";

export const StyledChatListBox = styled.div`
  padding: 2.4rem;
  padding-bottom: 0;
  height: 60.8rem;
  overflow-y: scroll;
  //   flex: 1;
  /* width */
  ::-webkit-scrollbar {
    width: 5px;
  }
  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #888;
  }
`;
export const StyledNoChatBox = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  // position: absolute;
  // top: 10%;
`;

export const StyleSingleChatBox = styled.div<{type: "received" | "sent"}>`
  margin-bottom: 8px;
  display: flex;
  flex-direction: column;
  align-items: ${({type}) => (type === "received" ? "flex-start" : "flex-end")};
  .chat-time {
    font-weight: 400;
    font-size: 1.2rem;
    margin-top: 4px;
    color: #8c8c8c;
  }
`;
export const StyledReceivedMessageBox = styled.div`
  background-color: #ebebeb;
  border-radius: 15px 15px 15px 0px;
  padding: 1.6rem;
  font-size: 1.4rem;
  color: #1c1726;
`;
export const StyledSentMessageBox = styled.div`
  background-color: #d9d9d9;
  border-radius: 15px 15px 0px 15px;
  padding: 1.6rem;
  font-size: 1.4rem;
  color: #1c1726;
`;
export const StyledChatMenu = styled.div`
  flex: 4;
  @media screen and (max-width: 768px) {
    flex: 1;
  }
`;
export const StyledChatBox = styled.div`
  flex: 8;
  @media screen and (max-width: 768px) {
    flex: 10;
  }
`;
